import { COMPONENT_STATES, COMPONENT_TYPE, DEFAULT_MEDIA_QUERY_PLATFORMS } from 'common/constants';
import { OTHER_PROPS } from 'common/constants/component-props';
import { createModel } from '../create-model';
import type { CreatedBuildingBlock } from '../creation-types';

export const infographic = (): CreatedBuildingBlock<typeof COMPONENT_TYPE.INFOGRAPHIC> =>
	createModel({
		type: COMPONENT_TYPE.INFOGRAPHIC,
		componentProps: {
			styles: {
				[COMPONENT_STATES.DEFAULT]: {
					[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {
						width: '600px',
						height: 'auto',
						maxWidth: '100%',
						boxSizing: 'border-box',
					},
					[DEFAULT_MEDIA_QUERY_PLATFORMS.MOBILE_LANDSCAPE]: {
						width: '100%',
						justifySelf: 'stretch',
						height: 'auto',
					},
					[DEFAULT_MEDIA_QUERY_PLATFORMS.MOBILE]: {
						width: '100%',
						justifySelf: 'stretch',
						height: 'auto',
					},
				},
			},
			other: {
				[COMPONENT_STATES.DEFAULT]: {
					[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {
						[OTHER_PROPS.infographic.selection]: null,
					},
				},
			},
		},
		children: [],
	}) satisfies CreatedBuildingBlock<typeof COMPONENT_TYPE.INFOGRAPHIC>;
